// De kop boven de QR-code: bij welke activiteit, welk formulier of welk
// onderzoek hoort deze code? Wie een poster ophangt wil dat zeker weten zonder
// eerst de link te openen (testronde 2026-10-28, Fatima B1).
//
// Puur: de QR-pagina haalt de documenten op en geeft ze hier in. Zolang een
// document nog niet binnen is, geeft hij '' — geen 'laden'-tekst die als naam
// gelezen kan worden.
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/**
 * @param {object} params
 * @param {string} params.route - 'research' | 'intakeform' | 'event' | 'storytelling'
 * @param {{Title?: string}} [params.research]
 * @param {{Title?: string}} [params.moment]
 * @param {{Title?: string}} [params.intakeForm]
 * @param {{Activity?: string}} [params.activity]
 * @returns {string} De kop, of '' als er (nog) niets te zeggen is
 */
const qrcodeSubject = ({ route, research, moment, intakeForm, activity }) => {
    switch (route) {
        case 'event':
            return activity ? `Activiteit: ${activity.Activity || ''}`.trim() : ''
        case 'intakeform':
            if (!intakeForm) return ''
            return intakeForm.Title ? `Formulier: ${intakeForm.Title}` : 'Formulier zonder titel'
        // Een deellink heeft geen naam om te noemen, en de soorten staan
        // server-side (StorytellingLinks is niet leesbaar vanuit de browser).
        case 'storytelling':
            return 'Storytelling insturen'
        case 'research':
            if (!research) return ''
            return moment?.Title
                ? `Onderzoek: ${research.Title} · ${moment.Title}`
                : `Onderzoek: ${research.Title}`
        default:
            return ''
    }
}

export default qrcodeSubject
